import { Component, Input, SimpleChanges, ViewChild } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ErrorModalComponent } from 'src/app/common/error-modal/error-modal.component';
import { EncryptionService } from 'src/app/services/encryption.service';
import { AppService } from 'src/app/services/services';

@Component({
  selector: 'nri-app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent {
  addressDisabled: boolean = true;
  bankDisabled: boolean = true;
  fatcaDisabled: boolean = true;
  foreignaddressDisabled: boolean = true;
  livelinessDisabled: boolean = true;
  mariner: boolean = false;
  nomineeDisabled: boolean= true;
  ocipioDisabled: boolean = true;
  passportDisabled: boolean = true;
  ridetailsDisabled: boolean = true;
  reStatus: string = '';
  StageSkip:string = '';
  segmentsDisabled: boolean = true;
  signatureDisabled :boolean = true;
  termsDisabled :boolean = true;
  stage: string = '/pan';
  visaDisabled: boolean = true;
    getnreNPIS: boolean = false;
    getnrePIS: boolean = false;
    getnroNPIS: boolean = false;
    getnroPIS: boolean = false;
    erefNo: string = '';
    panNumber: string = '';
    rihide: boolean ;
    public stageVal: boolean = false;
    NRO: string = '';
    @ViewChild('errorComp') errorComp : ErrorModalComponent;
    ref: string = "";
      EsignStatus : string = '';
      search : any = {};
  constructor(private router: Router, public _http: AppService,private http:EncryptionService, private loader:NgxUiLoaderService, private toastr:ToastrService){
    this._http.getRefNum().subscribe(data => {
      this.erefNo = data;
    });
    
    
    

    this._http.getStatus().subscribe(data => {
      this.panNumber = data.Pan;
    })
  }

  ngOnInit(){
    if(this.erefNo){
      this.getoverallStatus();
    }
    let url = window.location.pathname;
    this.setMenus(url,this.erefNo)
    this.router.events.subscribe(event =>{
      if (event instanceof NavigationStart){
        this.setMenus(event.url,this.erefNo)
      }
   })
   if(sessionStorage.getItem('ref')) {
      this.refEvent(sessionStorage.getItem('ref'))
   }
   if(sessionStorage.getItem('NRO')) {
      this.NRO= sessionStorage.getItem('NRO') || '';
   }
   this.search = JSON.parse(sessionStorage.getItem('searchParams') || '{}')
      if (Object.keys(this.search).length > 0) {
      this.EsignStatus = this.search['esign'];
    }
  }
 

  getoverallStatus(){
    let url = 'DIY/DIYOverallStatus';
    this.loader.start();
    let checkSum = this.erefNo;    
    let params = {
      'ReferenceNumber': this.erefNo,
    }
    this._http.httpPost(url,params, checkSum).subscribe({
      next: (data:any) => {
        this.loader.stop();
        let val=this.http.decryptUsingAES256(data.OutPut)
        if(val && val.IsSuccess){
          let item = val.overallLists;
          this.panNumber = val.PanNumber;
          this.StageSkip = item[3].StageSkip;
          this.NRO=val.NRO;
          sessionStorage.setItem('NRO',this.NRO);
          if(val.ReferenceNumber) {
            this.ref = val.ReferenceNumber;
          }
          if(item[12].DIY === "Y"){
            this.livelinessDisabled = false;
          }
          if(item[13].DIY === "Y"){
            this.signatureDisabled = false;
            this.termsDisabled = false;
          }
          if(item[2].DIY === "Y"){
            this.passportDisabled = false;
          }
           if(item[4].DIY === "Y"){
            this.foreignaddressDisabled = false;
          }
           if(item[5].DIY === "Y"){
            this.addressDisabled = false;
          }
           if(item[6].DIY === 'Y'){
            this.visaDisabled = false;
          }
           if(item[7].DIY === "Y" && item[11].DIY === "Y"){
            this.fatcaDisabled = false;
          }
           if(item[9].DIY === "Y"){
            this.bankDisabled = false;
          }
           if(item[10].DIY === "Y"){
            this.segmentsDisabled = false;
          }
        }
  
      },
      error: _error=>{
        this.loader.stop();
        // this.toastr.error(_error.error.Message)
        this.errorComp.ModalShow(_error.error.Message);
      }
    })
  }

  refEvent(event:string | null){
    if (event) this.ref = this.http.decryptUsingAES256(event);
  }
  overallStatus(ref?:any){
    let url = 'DIY/DIYOverallStatus';
    let checkSum = this.erefNo;    
    let params = {
      'ReferenceNumber': this.erefNo,
    }
    this._http.httpPost(url,params, checkSum).subscribe({
      next: (data:any) => {
        let val=this.http.decryptUsingAES256(data.OutPut)
        if(val && val.IsSuccess){
          let item = val.overallLists;
          this.panNumber = val.PanNumber;
          this.StageSkip = item[3].StageSkip;
          this.NRO=val.NRO;
          sessionStorage.setItem('NRO',this.NRO);
          if((item[12].DIY !== 'Y' || item[12].DBO === 'R') &&(this.NRO === 'Y')){
            this.router.navigate(['/photo'], { replaceUrl: true });
          }
          else if(item[2].DIY !== 'Y' || item[2].DBO === 'R'){
            this.router.navigate(['/passport'], { replaceUrl: true });
          }
          else if(val.ReStatus === 'FN' && item[3].DIY !== 'Y' || item[3].DBO === 'R'){
            this.router.navigate(['/oci-pio'], { replaceUrl: true });
          }
          else if(!val.Mariner && item[4].DIY !== 'Y' || item[4].DBO === 'R'){
            this.router.navigate(['/foreign-address'], { replaceUrl: true });
          }
          else if(item[5].DIY !== 'Y' || item[5].DBO === 'R'){
            this.router.navigate(['/address'], { replaceUrl: true });
          }
          else if(val.ReStatus !== 'FN' && item[6].DIY !== 'Y' || item[6].DBO === 'R'){
            this.router.navigate(['/visa'], { replaceUrl: true });
          } 
          else if(item[10].DIY !== 'Y' || item[10].DBO === 'R'){
            this.router.navigate(['/segments'], { replaceUrl: true });
          }
          else if(item[9].DIY !== 'Y' || item[9].DBO === 'R'){
            this.router.navigate(['/bank'], { replaceUrl: true });
          }
          else if(item[8].DIY !== 'Y' || item[8].DBO === 'R'){
            this.router.navigate(['/ridetails'], { replaceUrl: true });
          }
          else if(item[7].DIY !== 'Y' || item[7].DBO === 'R'){
            this.router.navigate(['/fatca'], { replaceUrl: true });
          }
          else if(item[11].DIY !== 'Y' || item[11].DBO === 'R'){
            this.router.navigate(['/nominee'], { replaceUrl: true });
          }else if((item[13].DIY !== 'Y' || item[13].DBO === 'R') &&(this.NRO === 'Y')){
            this.router.navigate(['/signature'], { replaceUrl: true });
          }
          else if(((item[13].DIY === 'Y' || item[14].DIY !== 'Y')&& (item[15].DIY !== 'Y' &&this.EsignStatus?.toLowerCase() !== 'failed'))&&(this.NRO === 'Y')){
              this.router.navigate(['/terms'], { replaceUrl: true });
           }
          else if(item[14].DIY !== 'Y' || item[14].DBO === 'R'){
            this.router.navigate(['/aof'], { replaceUrl: true });
          }
          else if((item[15].DIY !== 'Y' || item[14].DBO === 'R')&&(this.NRO === 'Y')){
            this.router.navigate(['/aof'], { replaceUrl: true });
          }
        }
  
      },
      error: _error=>{
        // this.toastr.error(_error.error.Message)
        this.errorComp.ModalShow(_error.error.Message);
      }
    })
  }

  setMenus(url: any, ref?:any){
    this.StageSkip = this._http.getOci();
    if(sessionStorage.getItem('ref')) {
      this.refEvent(sessionStorage.getItem('ref'))
    }
    this._http.getStatus().subscribe(data=>{
      if(data.Mariner){
        this.mariner = true;
      }else{
        this.mariner = false;
      }

      if(data.ReStatus === 'FN'){
        this.reStatus = data.ReStatus;
      }else{
        this.reStatus = data.ReStatus;
      }
    })
    if(url.includes('/pan')){
      this.stage='/pan';
    }
    if(url.includes("SBINRI_DIY")){
      let a  = url.split("/")[2];
      url = `/${a}`;
    }
    if(url.includes("SBINRIDIY")){
      let a  = url.split("/")[2];
      url = `/${a}`;
    }
    if(url === '/photo'){
      this.livelinessDisabled = false;
    }
   else if(url === '/passport'){
    this.livelinessDisabled = false;
      this.passportDisabled = false;
    }
    else if(url.includes('/oci-pio')){
      this.livelinessDisabled = false;
      this.passportDisabled = false;
      this.ocipioDisabled = false;
    }
    else if(url === '/foreign-address'){
      this.livelinessDisabled = false;
      this.passportDisabled = false;
      this.ocipioDisabled = false;
      this.foreignaddressDisabled = false;
    }
    else if(url === '/address'){
      this.livelinessDisabled = false;
      this.passportDisabled = false;
      this.ocipioDisabled = false;
      this.foreignaddressDisabled = false;
      this.addressDisabled = false;
    }
    else if(url === '/visa'){
      this.livelinessDisabled = false;
      this.passportDisabled = false;
      this.ocipioDisabled = false;
      this.foreignaddressDisabled = false;
      this.addressDisabled = false;
      this.visaDisabled = false;
    }
   
    
    else if(url === '/ridetails'){
      this.livelinessDisabled = false;
      this.passportDisabled = false;
      this.ocipioDisabled = false;
      this.foreignaddressDisabled = false;
      this.addressDisabled = false;
      this.visaDisabled = false;
      this.segmentsDisabled = false;
      this.bankDisabled = false;
      if(!this.rihide){
        this.ridetailsDisabled = true;
       }else{
        this.ridetailsDisabled = false;
       }
    }
    else if(url === '/fatca'){
      this.livelinessDisabled = false;
      this.passportDisabled = false;
      this.ocipioDisabled = false;
      this.foreignaddressDisabled = false;
      this.addressDisabled = false;
      this.visaDisabled = false;
      // this.segmentsDisabled = false;
      if(!this.rihide){
        this.ridetailsDisabled = true;
       }else{
        this.ridetailsDisabled = false;
       }
      this.fatcaDisabled = false;
    }
    else if(url === '/bank'){
      this.livelinessDisabled = false;
      this.passportDisabled = false;
      this.ocipioDisabled = false;
      this.foreignaddressDisabled = false;
      this.addressDisabled = false;
      this.visaDisabled = false;
      // this.segmentsDisabled = false;
      this.bankDisabled = false;
      this.fatcaDisabled = false;
    }
    else if(url === '/segments'){
      this.livelinessDisabled = false;
      this.passportDisabled = false;
      this.ocipioDisabled = false;
      this.foreignaddressDisabled = false;
      this.addressDisabled = false;
      this.visaDisabled = false;
      this.segmentsDisabled = false;
      this.fatcaDisabled = false;
      this.bankDisabled = false;
    }
    else if(url === '/signature'){
      this.livelinessDisabled = false;
      this.passportDisabled = false;
      this.ocipioDisabled = false;
      this.foreignaddressDisabled = false;
      this.addressDisabled = false;
      this.visaDisabled = false;
      this.segmentsDisabled = false;
      this.bankDisabled = false;
      this.signatureDisabled = false;
    }
      else if(url === '/terms'){
      this.livelinessDisabled = false;
      this.passportDisabled = false;
      this.ocipioDisabled = false;
      this.foreignaddressDisabled = false;
      this.addressDisabled = false;
      this.visaDisabled = false;
      this.segmentsDisabled = false;
      this.bankDisabled = false;
      this.signatureDisabled = false;
      this.termsDisabled = false;
    }

    // else if(url === '/nominee'){
    //   this.passportDisabled = false;
    //   this.ocipioDisabled = false;
    //   this.foreignaddressDisabled = false;
    //   this.addressDisabled = false;
    //   this.visaDisabled = false;
    //   this.segmentsDisabled = false;
    //   this.bankDisabled = false;
    //   if(this.rihide == false){
    //     this.ridetailsDisabled == true;
    //    }else{
    //     this.ridetailsDisabled == false;
    //    }
    //   this.fatcaDisabled = false;
    //   this.nomineeDisabled = false;
    // }
    else if( url === '/aof' || url === '/complete'){
      this.passportDisabled = false;
      this.ocipioDisabled = false;
      this.foreignaddressDisabled = false;
      this.addressDisabled = false;
      this.visaDisabled = false;
      this.segmentsDisabled = false;
      this.bankDisabled = false;
      this.termsDisabled = false;
      if(!this.rihide){
        this.ridetailsDisabled = true;
       }else{
        this.ridetailsDisabled = false;
       }
      this.fatcaDisabled = false;
      this.nomineeDisabled = false;
      this.livelinessDisabled = false;
      this.signatureDisabled = false;
    }
    this.tab(url,ref)
  }
  tab(m: string,ref?:any){
    this.stageVal = this._http.getComplete();
    if(this.stageVal){
      this.segmentsDisabled = false;
      this.stage = m;
    }

    if(m.includes("SBINRI_DIY")){
      let a  = m.split("/")[2];
      m = `/${a}`;
    }
    if(m.includes("SBINRIDIY")){
      let a  = m.split("/")[2];
      m = `/${a}`;
    }
    if(m === "/complete"){
      this.stageVal = true;
      this.stage = m;
      this.segmentsDisabled = false;
    }else {
      this.stageVal = false;
    }
    if(!this.stageVal) {
      this.stage = m;
      if(this.stage === `/SBINRI_DIY${m}`){
        this.stage = m;
      }
      if(this.stage === `/SBINRIDIY${m}`){
        this.stage = m;
      }
    }
    
  }
}
